<template>
    <div id="app">
      <Navbar></Navbar>
      <Preloader></Preloader>

      <div id="scroller">
        <Page></Page>
      </div>
    </div>
</template>

<script>
import Navbar from './components/Menu'
import Preloader from './components/Preloader'


import Page from './Page'

export default {
  name: 'app',
  components: {
    Preloader,
    Navbar,
    Page
  },
  mounted () {

    const links = document.links;

    for (let i = 0; i < links.length; i++) {
      const link = links[i];
      if (!link.hash)
        continue;
      link.addEventListener("click", (e) => {
        e.preventDefault();
        const anchor = document.querySelector(link.hash);
        anchor.scrollIntoView({ behavior: 'smooth', block: 'start'});
      });

    }
  }
}
</script>



// WEBPACK FOOTER //
// src/App.vue